import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'wr-unsupported-widget',
  standalone: true,
  template: `
  <div
    class="text-sm p-3 mx-5 rounded-md"
    style="background: #929292;color:white;"
  >
    @if (language === 'de') {
      Dieses Feature ist derzeit nicht im Browser verfügbar.<br />
      Bitte verwenden Sie den <strong>Narravero Reader</strong> für <a style="color: unset;text-decoration: underline;"
          href="https://apps.apple.com/de/app/narravero-reader/id6444441555" target="_blank">iOS</a> oder <a style="color: unset;text-decoration: underline;"
          href="https://play.google.com/store/apps/details?id=com.narravero.reader" target="_blank">
          Android
        </a>
    } @else {
      This feature is currently not available in the browser.<br />
      Please use the <strong>Narravero Reader</strong> for <a style="color: unset;text-decoration: underline;"
          href="https://apps.apple.com/de/app/narravero-reader/id6444441555" target="_blank">iOS</a> or <a style="color: unset;text-decoration: underline;"
          href="https://play.google.com/store/apps/details?id=com.narravero.reader" target="_blank">
          Android
        </a>
    }

  </div>
  `,
})
export class UnsupportedWidgetComponent implements OnInit {
  @Input() type!: string;
  @Input() language?: 'de' | 'en';

  ngOnInit() {
    if (!this.language) {
      const browserLang = navigator.language || 'en';
      this.language = browserLang.startsWith('de') ? 'de' : 'en';
    }
  }

}

/*
  Unsupported widget type:
  <strong>{{ type }}</strong>
*/